import axios, { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { PushApplicationState, PushApplicationFilterParams, PushApplicationItem } from './types';


export const actions: ActionTree<PushApplicationState, RootState> = {
  async getPushApplications({commit}, filter: PushApplicationFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{ applications: PushApplicationItem[] }> = await axios({
        url: "/acapi/push/applications",
        params: filter,
      });
      commit("setPushApplications", resp.data.applications);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getPushApplicationItem({commit}, id: number) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<PushApplicationItem> = await axios({
        url: `/acapi/push/applications/${id}`
      });
      const application: PushApplicationItem = resp.data;
      application.id = id;
      commit("setPushApplication", application);
      return application;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getPushPlatforms({commit}) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<[{platform: string}]> = await axios({
        url: "/acapi/push/platforms",
      });
      commit("setPushPlatforms", resp.data);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getPushOS({commit}) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<[{os: string}]> = await axios({
        url: "/acapi/push/os",
      });
      commit("setPushOS", resp.data);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async savePushApplication({commit, dispatch}, item: PushApplicationItem) {
    commit('setLoading', true);
    try {

      const resp:AxiosResponse<any> = await axios({
        method: item.id ? 'put' : 'post',
        url: `/acapi/push/applications/${(item.id ?? '')}`,
        data: item,
      })
      dispatch('getPushApplications');
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
  async deletePushApplication({commit, dispatch}, item: PushApplicationItem) {
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<any> = await axios({
        method: 'delete',
        url: `/acapi/push/applications/${(item.id ?? '')}`,
        data: item,
      })
      dispatch('getPushApplications');
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
  async uploadCertFile({commit}, item: any) {
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<{path: string}> = await axios({
        method: 'post',
        url: `/acapi/push/applications/certificate`,
        data: item,
      })
      return resp.data.path;
    } finally {
      commit('setLoading', false);
    }
  },
}
